module.exports = __webpack_public_path__ + "img/roemisch.ad9209d0.png";